import { Injectable, Pipe, PipeTransform } from '@angular/core';
/*
  Generated class for the FiltroRespostaValor pipe.

  See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
  Angular 2 Pipes.
*/
@Pipe({
    name: 'filtrorespostavalor',
    pure: false
})
@Injectable()
export class FiltroRespostaValor implements PipeTransform {
    transform(items: any[], arg: any): any {
      
        if (items != null) {
            return items
                .filter(item => item.valor.indexOf(arg) !== -1)
        }
    }
}



// WEBPACK FOOTER //
// ./src/pipes/filtro-resposta-valor.ts